import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import moment from 'moment';
import DialogContainer from 'components/DialogContainer/styles';
import DialogClose from 'components/DialogClose/styles';
import DialogBody from 'components/DialogBody/styles';
import DialogTitle from 'components/DialogTitle/styles';
import {DialogSubTitle} from 'components/DialogSubTitle/styles';
import {ButtonPrimary} from 'components/buttons';
import DialogActions from 'components/DialogActions/styles';
import DialogAction from 'components/DialogAction/styles';
import Body1 from 'components/typography/Body1';
import IconThumbUp from 'assets/icon_thumb_up.png';
import IconThumbDown from 'assets/icon_thumb_down.png';
import IconBlock from 'assets/icon_blocked.png';
import {
  DriverRatingViewContainer,
  DriverInfo,
  RatingTag,
  RatingTagsContainer,
  SubmittedDate,
  RatingDetails
} from './styles';

const RATING_TYPES = {
  GOOD: 'Good',
  NEEDS_IMPROVEMENT: 'Needs improvement',
  BLOCK_DRIVER: 'Block Driver'
};

const DriverRatingViewModal = ({
  isOpen,
  onClose,
  driverName,
  rating,
  onModify
}) => {
  const getRatingIcon = () => {
    switch (rating?.ratingType) {
      case RATING_TYPES.GOOD:
        return <img src={IconThumbUp} alt='Good' />;
      case RATING_TYPES.NEEDS_IMPROVEMENT:
        return <img src={IconThumbDown} alt='Needs Improvement' />;
      case RATING_TYPES.BLOCK_DRIVER:
        return <img src={IconBlock} alt='Block Driver' />;
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return moment(dateString).format('MMMM D, YYYY');
  };

  return (
    <Dialog open={isOpen} scroll='body' onClose={onClose}>
      <DialogContainer className='DialogMd'>
        <DialogClose onClick={onClose} />
        <DialogTitle className='DialogTitleLeft'>Driver rating</DialogTitle>
        <DialogSubTitle className='marginTopMd'>
          We&apos;ll use your feedback to improve future deliveries.
        </DialogSubTitle>
        <DialogBody>
          <DriverRatingViewContainer>
            <DriverInfo>
              <Body1 style={{fontSize: '18px', fontWeight: 600}}>
                {driverName || 'Driver'}
              </Body1>
              {getRatingIcon()}
            </DriverInfo>

            {rating?.selectedReasons && rating.selectedReasons.length > 0 && (
              <RatingTagsContainer>
                {rating.selectedReasons.map((reason) => (
                  <RatingTag key={reason}>{reason}</RatingTag>
                ))}
              </RatingTagsContainer>
            )}

            {rating?.details && typeof rating?.details === 'string' && (
              <RatingDetails>{rating.details}</RatingDetails>
            )}

            {rating?.createdAt && (
              <SubmittedDate>
                Submitted on {formatDate(rating.createdAt)}
              </SubmittedDate>
            )}
          </DriverRatingViewContainer>

          <DialogActions className='justifyEnd marginT10'>
            <DialogAction className='w40'>
              <ButtonPrimary
                onClick={onModify}
                style={{backgroundColor: '#ff2d38'}}
              >
                <span>Modify rating</span>
              </ButtonPrimary>
            </DialogAction>
          </DialogActions>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

DriverRatingViewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  driverName: PropTypes.string,
  rating: PropTypes.shape({
    id: PropTypes.string,
    locationId: PropTypes.string,
    locationName: PropTypes.string,
    associatedOrderId: PropTypes.string,
    associatedInvoiceId: PropTypes.string,
    associatedOrderSource: PropTypes.string,
    dispatchProviderVersion: PropTypes.string,
    deliveryCompany: PropTypes.string,
    deliveryProviderOrderId: PropTypes.string,
    driverName: PropTypes.string,
    vehicleType: PropTypes.string,
    ratingType: PropTypes.string,
    selectedReasons: PropTypes.arrayOf(PropTypes.string),
    details: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string
  }),
  onModify: PropTypes.func.isRequired
};

DriverRatingViewModal.defaultProps = {
  driverName: null,
  rating: null
};

export default DriverRatingViewModal;
